/* eslint-disable react/display-name */
import { useMemo } from 'react'
import { Link, useParams } from 'react-router-dom'
import { ContentBody, Table } from '../../../../core/components'
import { routesConfig } from '../../../../core/configs/routes'
import { CustomerType } from '../../../../entities'
import { useCustomerServiceOrders } from '../../../../services/queries/customer'
import { dateTimeFormat } from '../../../../utils/format/dateTimeFormat'

export const ServiceOrdersTab = () => {
  const { id }: any = useParams()
  const {
    data: lastProducts,
    error,
    isLoading
  }: any = useCustomerServiceOrders({
    page: 1,
    limit: 999,
    id
  })

  const columns = useMemo(
    () => [
      {
        title: 'Nº Ordem de Serviço',
        dataIndex: 'id',
        key: 'id',
        render: (value: any, row: any) => {
          return (
            <Link
              to={
                routesConfig.ordersOfService.serviceOrder.details +
                `/${row.id}/detalhes`
              }
            >
              {value}
            </Link>
          )
        }
      },
      {
        title: 'Cliente',
        dataIndex: 'customer',
        render: (value: CustomerType) => (value ? value.name : '')
      },
      {
        title: 'Produto',
        dataIndex: 'item',
        render: (value: any) => value.name
      },
      {
        title: 'Data/Hora',
        dataIndex: 'date',
        key: 'date',
        render: (value: string) => (value ? dateTimeFormat(value) : null)
      }
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  )

  if (isLoading) {
    return null
  }

  if (error) {
    return <div>ALGUM ERRO ACONTECEU</div>
  }

  return (
    <>
      <ContentBody>
        <Table
          dataSource={lastProducts?.data || []}
          columns={columns}
          bordered
        />
      </ContentBody>
    </>
  )
}
